<template>
    <div class="webContent">
        <div class="header">
            <p>敏捷专有云资源计算器</p>
        </div>
        <div class="leftContent">
            <div class="content">
                <p class="headerTitle">资源配置项</p>
                <div class="paramsDiv">
                    <p class="title">vCPU</p>
                    <el-input type="number" v-model.trim="formData.vCPU"
                              oninput="value=value==''?0:parseInt(value.replace(/[^\d.]/g,''))"
                              placeholder="请输入vCPU">
                        <template slot="append">核</template>
                    </el-input>
                    <p class="detail">平台提供的云主机虚拟核数</p>
                </div>
                <div class="paramsDiv">
                    <p class="title">Memory</p>
                    <el-input type="number" v-model.trim="formData.memory"
                              oninput="value=value==''?0:parseInt(value.replace(/[^\d.]/g,'')) "
                              placeholder="请输入memory">
                        <template slot="append">GB</template>
                    </el-input>
                    <p class="detail">平台提供的云主机内存数</p>
                </div>
                <div class="paramsDiv">
                    <p class="title">HDD</p>
                    <el-input type="number" v-model.trim="formData.hdd"
                              oninput="value=value==''?0:parseInt(value.replace(/[^\d.]/g,'')) "
                              placeholder="请输入HDD">
                        <template slot="append">TB</template>
                    </el-input>
                    <p class="detail">平台提供的HDD存储大小</p>
                </div>
                <div class="paramsDiv">
                    <p class="title">SSD</p>
                    <el-input type="number" v-model.trim="formData.ssd"
                              oninput="value=value==''?0:parseInt(value.replace(/[^\d.]/g,'')) "
                              placeholder="请输入SSD">
                        <template slot="append">TB</template>
                    </el-input>
                    <p class="detail">平台提供的SDD存储大小</p>
                </div>
                <div class="paramsDiv">
                    <p class="title">CPU超卖比</p>
                    <el-select style="width: 100%;" v-model="formData.cpuScale" placeholder="请选择">
                        <el-option
                                v-for="item in cpuScaleOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <p class="detail">虚拟CPU的比例</p>
                </div>
            </div>
            <div class="content" style="padding: 15px 0">
                <p class="headerTitle">网络与安全</p>
                <div class="paramsDiv">
                    <p class="title">网络设备</p>
                    <el-select style="width: 100%" v-model="formData.vpcDevice" placeholder="请选择">
                        <el-option
                                v-for="item in vpcDeviceOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <p class="detail">交换机配置方式</p>
                </div>
                <el-row style="margin: 30px 0;text-align: center">
                    <el-button size="medium" id='reset'  style="background: #ffffff;color: #212121;border-color: #b5b5b5" plain round @click="resetAction">重置参数</el-button>
                    <el-button id='shengcheng' style="background: #4762fe;color: white; border: none;" size="medium"  plain round @click="setAction">生成方案</el-button>
                </el-row>
            </div>

        </div>
        <div class="contentBody">
            <p class="headerTitle">方案清单</p>
            <div v-show="!hasParams" class="noParamsBody">
                <img src="../assets/image/noParams.png" alt="">
                <div class="detail">请填写参数生成方案</div>
                <el-button class="noParamsButton" id="zixun1" style="background: #4762fe;color: white;border: none;" @click="pushAdvisorService" size="medium" type="primary" plain round>咨询服务</el-button>
            </div>
            <div v-show="hasParams" class="haveParamsBody">
                <div class="topBody">
                    <p class="title">资源列表</p>
                    <p class="params">vCPU: {{currentFormData.vCPU}} 核</p>
                    <p class="params">内存: {{currentFormData.memory}} GB</p>
                    <p class="params">HDD存储: {{currentFormData.hdd}} TB</p>
                    <p class="params">SSD存储: {{currentFormData.ssd}} TB</p>
                    <p class="params">CPU超卖比: {{cpuScaleOptions.filter(item => item.value == currentFormData.cpuScale)[0]['label']}}</p>
                    <p class="params"></p>
                </div>
                <div class="bottomBody">
                    <el-tabs v-model="currentFormData.tapActiveName" style="width: 880px;" @tab-click="handleClick">
                        <el-tab-pane label="敏捷标准版" name="standard"></el-tab-pane>
                        <el-tab-pane v-if="blendTapHidden" label="敏捷混合部署版" name="blend"></el-tab-pane>
                        <el-tab-pane v-if="superTapHidden" label="超融合版" name="super"></el-tab-pane>
                    </el-tabs>
                    <div class="bottomBodyContent">
                        <p class="topTitle">方案介绍</p>
                        <p class="topDetail" style="white-space: pre-line">{{topDetailObj.detail}}</p>
                        <p class="topTitle" style="margin-top: 30px">方案架构图</p>
                        <img :src="topDetailObj.img" alt="">
                        <p class="topTitle" style="margin-top: 30px">方案及资源配置列表</p>
                    </div>
                    <el-table
                            :data="topTableArray"
                            :span-method="topObjectSpanMethod"
                            border
                            style="width: 100%; margin-top: 20px">
                        <el-table-column
                                prop="describe"
                                label="描述">
                        </el-table-column>
                        <el-table-column
                                prop="deviceType"
                                label="设备类型">
                        </el-table-column>
                        <el-table-column
                                prop="port"
                                label="部署节点">
                        </el-table-column>
                        <el-table-column
                                prop="num"
                                label="数量">
                        </el-table-column>
                    </el-table>
                    <el-table
                            :data="bottomTableArray"
                            :span-method="bottomObjectSpanMethod"
                            border
                            style="width: 100%; margin-top: 20px">
                        <el-table-column
                                prop="describe"
                                label="描述">
                        </el-table-column>
                        <el-table-column
                                prop="resourceType"
                                label="资源类型">
                        </el-table-column>
                        <el-table-column
                                prop="need"
                                label="需求量">
                        </el-table-column>
                        <el-table-column
                                prop="supply"
                                label="提供量">
                        </el-table-column>
                    </el-table>
                    <el-button size="medium" id = "zixun2" style="margin-top: 40px;background: #4762fe;color: white;border: none;" @click="pushAdvisorService" type="primary" plain round>咨询服务</el-button>
                </div>
            </div>
        </div>
        <div style="clear: both"></div>
    </div>
</template>
<style>
    .el-select-dropdown__item.selected {
        color: #4762fe;
        font-weight: 700;
    }
    .el-tabs__item.is-active {
        color: #4762fe;
    }
    .el-tabs__active-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        background-color: #4762fe;
        z-index: 1;
        transition: transform .3s cubic-bezier(.645,.045,.355,1);
        list-style: none;
    }
    .el-tabs__item:hover {
        color: #4762fe;
        cursor: pointer;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
        border-color: #4762fe;
        outline: 0;
    }
    .el-select .el-input.is-focus .el-input__inner {
        border-color: #4762fe;
    }
    .el-select .el-input__inner:focus {
        border-color: #4762fe;
    }
</style>
<script>
    export default {
        name: "webContent",
    }
</script>
<script>
    $(function(){
        var sign=document.getElementById("shengcheng");
        change(sign)
    });
    $(function(){
        var sign=document.getElementById("zixun1");
        change(sign)
    });
    $(function(){
        var sign=document.getElementById("zixun2");
        change(sign)
    });
    $(function(){
        var reset=document.getElementById("reset");
        change2(reset)
    });
    function change(sign) {
        sign.onmouseover = function () {
            sign.style.background = "#5f77ff";
        }
        sign.onmouseout = function () {
            sign.style.background = "#4762fe";
        };
    }
    function change2(sign) {
        sign.onmouseover = function () {
            sign.style.borderColor = "#666666";
        }
        sign.onmouseout = function () {
                sign.style.borderColor = "#b5b5b5";
            };
    }
</script>

